import { type QueryConstraint, where } from "firebase/firestore";
import { useFirestore } from "../useFirestore";
import type { Always } from "types/utilities";
import { useMemo } from "react";
import { transformPickemsEntry } from "./shared";
import { pickemsEntry } from "../models/entries";

const usePickemsEntries = (queryConstraints: QueryConstraint[] = []) => {
  const { data, isLoading, error } = useFirestore(
    "/users/{userId}/entries",
    pickemsEntry.array(),
    {
      query: [where("entryType", "==", "PICKEM"), ...queryConstraints],
      keyPath: "contestId",
    },
  );

  const entries = useMemo(() => {
    if (!data) return [];

    return data.map(transformPickemsEntry);
  }, [data]);

  return { entries, isLoading, error } as const;
};

export const useLivePickemsEntries = () => {
  const { entries, isLoading, error } = usePickemsEntries([
    where("status", "in", ["live", "upcoming"]),
  ]);

  return { entries, isLoading, error } as const;
};

export type PickemsEntries = Always<
  ReturnType<typeof usePickemsEntries>["entries"]
>;
